(function () {
  'use strict';

  var fab = document.querySelector('[data-mg-help-hub-fab]');
  var panel = document.querySelector('[data-mg-help-hub-panel]');
  if (!fab || !panel) return;

  function setOpen(open) {
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    fab.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('mg-help-hub-open', open);
  }

  fab.addEventListener('click', function () {
    setOpen(!panel.classList.contains('is-open'));
  });

  var closeBtn = panel.querySelector('[data-mg-help-hub-close]');
  if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setOpen(false);
  });

  panel.querySelectorAll('[data-mg-help-action]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var action = btn.getAttribute('data-mg-help-action');
      setOpen(false);
      if (action === 'sales') {
        if (typeof window.MG_OPEN_WHATSAPP_SALES === 'function') {
          window.MG_OPEN_WHATSAPP_SALES('general');
        } else {
          var salesFab = document.querySelector('[data-mg-sales-wa-fab]');
          if (salesFab) salesFab.click();
        }
        return;
      }
      if (action === 'coach') {
        var coachFab = document.querySelector('[data-mg-coach-fab]');
        if (coachFab) coachFab.click();
      }
    });
  });
})();